<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Material"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.material"
                        :request-query-string-params="{grupo_tipo_id: enums.tipoGrupo.MEDICAMENTO}"
                        :search-fields="fields.autocomplete"
                        :validations="validations.material"
                        label="Medicamento"
                        text-field="descricao"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-table
                        :fields="fields.table"
                        :items="items"
                        ref="RkmTable"
                    >
                        <template v-slot:cell(actions)="row">
                            <rkm-button
                                @click="destroy(row.index)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="store"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import tipoGrupo from '@/enums/cadastro/grupo/tipoGrupo'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
        validations() {
            return {
                material: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            tabelaObm: this.getConectaSusRepository('parametrizacao.tabelaObm'),
        }
    },
    data: () => ({
        enums: {tipoGrupo},
        fields: {
            autocomplete: [
                {key: 'codigo_material', searchable: true},
                {key: 'descricao', searchable: true},
            ],
            table: [
                {key: 'descricao', label: 'Descrição', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        id: null,
        items: [],
        model: {
            material: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(id) {
            this.reset()

            this.id = id

            this.show(this.id)

            this.$refs.RkmModal.show()
        },
        show(id) {
            this.setLoading()

            this.repositories.tabelaObm.show(id)
                .then(response => this.items = response.data.materiais)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.items && this.items.find(item => item.id === this.model.material.id)) {
                        this.showValidationNotification('O material já foi incluído.')
                        return
                    }

                    this.items.push({
                        id: this.model.material.id,
                        descricao: this.model.material.descricao,
                    })

                    this.clean()
                })
        },
        store() {
            this.setLoading()

            const request = {
                medicamentoId: this.id,
                materiais: this.items.map(item => (item.id))
            }

            this.repositories.tabelaObm.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.$refs.RkmModal.hide()
                    this.$emit('saved')
                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o material?', async () => {
                this.items.splice(index, 1)
            })
        },
        clean() {
            this.model.material = null
            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        reset() {
            this.id = null
            this.items = []
            this.model.material = null
        },
    },
    mixins: [error, repository, stringCase],
}
</script>